import { alpha } from '@mui/material/styles';
import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  toast: {
    '.Toastify__toast': {
      width: 'max-content',
    },
    '.Toastify__toast, .Toastify__toast--rtl': {
      border: `1px solid ${theme.palette.extendedGrey?.light}`,
      borderRadius: '12px',
      boxShadow: `0px 1px 2px 1px ${alpha(
        theme.palette.extendedGrey?.darkest ?? theme.palette.grey[900],
        0.05,
      )}`,
    },
    '.Toastify__progress-bar--success': {
      backgroundColor: theme.palette.success.light,
    },
    '.Toastify__progress-bar--error': {
      backgroundColor: theme.palette.error.light,
    },
  },
}));
